<style lang="less" scoped>
// .imgTitleContent{position: relative;width: 780px;height: 160px;display: flex;border-bottom: solid rgb(173, 172, 172);border-width:1px;overflow: hidden;font-family: AlibabaPuHuiTi-Regular;margin-bottom: 18px;}
// .boxWrap {width: 792px;height: 148px;border-width: 1px;margin-top:15px;margin-bottom:0;transition:all 0.7s;border-bottom:1px dashed #eee;cursor: pointer;}
// .picbox {position: absolute;left: 5px;width: 256px;height: 128px;overflow: hidden;border: 1px solid #eee;}
// .picbox img{width: 256px;height: 128px;margin-right: 20px;transition: transform .5s;}
// .box{position: absolute;left: 280px;margin: 0px;}
// p{margin: 0px;}
// .title{font-size: 16px;font-weight: 600;	line-height: 20px;letter-spacing: 0px;color: #08032b;}
// .title:hover{color: #13569e;;}
// .content{font-size: 12px;margin-top: 14px;margin-bottom: 24px;margin-right: 12px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;	line-height: 18px;letter-spacing: 1px;color: #666666;}
// .content{height: 32px;line-height: 16px; overflow:hidden;}
// .content::after{content: ' ... ';}
// .time{font-size: 12px;margin-top: 14px;	line-height: 18px;letter-spacing: 1px;color: #666666;}
// .address{font-size: 12px;margin-top: 5px;}
@import url('../../../style/common/variable.less');
  .imgTitleContent{height: 160px;display: flex;border-bottom: solid rgb(173, 172, 172);border-width:1px;overflow: hidden;font-family: AlibabaPuHuiTi-Regular;margin-bottom: 18px;}
  .boxWrap {height: 148px;border-width: 1px;margin-top:15px;margin-bottom:0;transition:all 0.7s;border-bottom:1px dashed #eee;cursor: pointer;}
  .picbox {overflow: hidden;border: 1px solid #eee;}
  .picbox img{transition: transform .5s;}
  // .box{position: absolute;left: 280px;margin: 0px;}
  p{margin: 0px;}
  .title{font-size: 16px;font-weight: 600;	line-height: 20px;letter-spacing: 0px;color: #08032b;}
  .title:hover{color: #13569e;;}
  .content{font-size: 12px;margin-top: 14px;margin-bottom: 24px;margin-right: 12px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;	line-height: 18px;letter-spacing: 1px;color: #666666;}
  // .content{height: 32px;line-height: 16px; overflow:hidden;}
  .content::after{content: ' ... ';}
  .time{font-size: 12px;margin-top: 14px;	line-height: 18px;letter-spacing: 1px;color: #666666;}
  .address{font-size: 12px;margin-top: 5px;}
@media screen and (min-width: @max-screen)
{
  .imgTitleContent{position: relative;width: 780px;}
  .boxWrap {width: 792px;}
  .picbox {position: absolute;width: 256px;left: 5px;height: 128px;}
  .picbox img{width: 256px;height: 128px;margin-right: 20px;}
  .box{position: absolute;left: 280px;margin: 0px;}
  .content{height: 32px;line-height: 16px; overflow:hidden;}
  .time{margin-top: 14px;}
}

@media screen and (max-width: @max-screen)
{
  .imgTitleContent{width: 100%;}
  .boxWrap {width: 100%;display: flex;}
  .picbox {width: 40%;height: 100%;}
  .picbox img{width: 100%;height: 100%;}
  .box{width: 55%;margin-left: 5%;display: flex;justify-content: space-around;flex-direction: column;height: 100%;}
  .content{height: 45%;line-height: 16px; overflow:auto;margin: 0;}
  .time{margin-top: 0px;}
}
</style>

<!--安进 2021.7.6 专家详情文章-->
<template>
  <div class="imgTitleContent" @click="handleClick(imgTitleContentItem)">
    <div class="boxWrap">
      <div class="picbox">
        <img :src="imgTitleContentItem.pic" />
      </div>
      <div class="box">
        <p class="title"> {{ imgTitleContentItem.title }} </p>
        <p class="content"> {{ imgTitleContentItem.introduce }} </p>
        <p class="time"> {{ imgTitleContentItem.release}}：{{ imgTitleContentItem.time * 1000 | formatDate() }} </p>
      </div>
    </div>
  </div>
</template>

<script>
import filters from '../method/filter.js'
export default {
  props: ['imgTitleContentItem'],
  mixins: [filters],
  data()
  {
    return {}
  },
  updated()
  {
    var oList = document.querySelectorAll('.content')
    var alltableArray = Array.prototype.slice.call(oList)
    alltableArray.forEach(function(item)
    {
      var oHeight = item.height
      if ((oHeight / 15) > 2)
        item.className = 'content'
    })
  },
  // 点击图片、标题、内容，将 被点击的整个信息对象 传递给父组件
  methods: {
    handleClick(item)
    {
      this.$emit('handleClick', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/ZJImgTitleContent.vue